module.exports = __webpack_public_path__ + "img/chocolate-nests.eb3eebb4.jpg";